"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDocumentStyles = void 0;
const api_1 = require("../api");
const generateDocumentStyles = (settings, docType) => {
    let baseStyles = `
    body {
      color: ${settings.common.textColor};
      font-family: ${settings.common.fontFamily};
      font-size: ${settings.common.fontSize}px;
      margin: 0;
      padding: 0;
    }

    .word-page > .header, .pdf-page > .header {
      display: ${settings.headerFooter.showHeader ? "block" : "none"};
      padding: 10px;
      text-align: ${settings.common.horizontalAlignment};
      font-weight: bold;
      border-bottom: 1px solid ${settings.common.accentColor};
      color: ${settings.common.accentColor};
    }

    .word-page > .footer, .pdf-page > .footer {
      display: ${settings.headerFooter.showFooter ? "block" : "none"};
      padding: 10px;
      text-align: ${settings.common.horizontalAlignment};
      font-weight: bold;
      border-top: 1px solid ${settings.common.accentColor};
      color: ${settings.common.accentColor};
    }

    .content {
      padding: ${settings.common.contentSpacing}px;
      text-align: ${settings.common.horizontalAlignment};
      display: flex;
      flex-direction: column;
      justify-content: ${settings.common.verticalAlignment === "middle" ? "center" : "flex-start"};
      align-items: ${settings.common.horizontalAlignment === "center"
        ? "center"
        : settings.common.horizontalAlignment === "right"
            ? "flex-end"
            : "flex-start"};
      min-height: calc(100% - 80px); /* leave space for header/footer */
      flex: 1;
    }
  `;
    // ✅ Word-specific rules
    if (docType === api_1.DOC_TYPE.WORD) {
        baseStyles += `
      .word-page {
        width: ${settings.word.pageSize === "A4" ? "8.27in" : "8.5in"};
        min-height: ${settings.word.pageSize === "A4" ? "11.69in" : "11in"};
        background: ${settings.common.backgroundColor};
        margin: 20px auto;
        padding: ${settings.word.marginTop}px ${settings.word.marginRight}px ${settings.word.marginBottom}px ${settings.word.marginLeft}px;
        box-shadow: 0 0 10px rgba(0,0,0,0.1);
        page-break-after: always;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        color: ${settings.common.textColor};
        font-family: ${settings.common.fontFamily};
        font-size: ${settings.common.fontSize}px;
      }
    `;
    }
    // ✅ PPT-specific rules
    if (docType === api_1.DOC_TYPE.PPT) {
        baseStyles += `
      .slide {
        height: auto !important;
        aspect-ratio: 16/9;
        background: ${settings.common.backgroundColor};
        margin: 20px auto;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: ${settings.common.verticalAlignment === "middle"
            ? "center"
            : "flex-start"} !important;
      align-items: ${settings.common.horizontalAlignment === "center"
            ? "center"
            : settings.common.horizontalAlignment === "right"
                ? "flex-end"
                : "flex-start"} !important;
        box-shadow: 0 0 10px rgba(0,0,0,0.1);
        box-sizing: border-box;
        page-break-after: always;
        position: relative;
        padding: ${settings.word.marginTop}px ${settings.word.marginRight}px ${settings.word.marginBottom}px ${settings.word.marginLeft}px;
        color: ${settings.common.textColor};
        font-family: ${settings.common.fontFamily};
        font-size: ${settings.common.fontSize}px;
      }
      .slide-break { display: none; }
    `;
        if (settings.ppt.transition === "fade") {
            baseStyles += `
        .slide {
          transition: opacity 0.5s ease;
        }
      `;
        }
    }
    // ✅ PDF-specific rules
    if (docType === api_1.DOC_TYPE.PDF) {
        baseStyles += `
      .pdf-page {
        width: ${settings.pdf.paperSize === "A4" ? "8.27in" : "8.5in"};
        min-height: ${settings.pdf.paperSize === "A4" ? "11.69in" : "11in"};
        background: white;
        margin: 20px auto;
        padding: 40px !important;
        box-shadow: 0 0 10px rgba(0,0,0,0.1);
        page-break-after: always;
        position: relative;
      }
    `;
        if (settings.pdf.includePageNumbers) {
            baseStyles += `
        .page-number {
          position: absolute;
          bottom: 10px;
          right: 20px;
          font-size: 12px;
          color: ${settings.common.accentColor};
        }
      `;
        }
    }
    return baseStyles;
};
exports.generateDocumentStyles = generateDocumentStyles;
